import React, { Component } from "react";
import { withAuthorization } from "../Session";
import { withFirebase } from "../Firebase";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import NavigationMenus from "../NavigationMenus";
import OverlayAlertBox from "./OverlayAlertBox";
import {
  Breadcrumbs,
  Chip,
  Typography,
  Link,
  Grid,
  Paper,
  Button,
  LinearProgress,
} from "@material-ui/core";
import * as ROUTES from "../../constants/route";
import { InfoOutlined, AttachFileOutlined } from "@material-ui/icons";
import { AuthUserContext } from "../Session";
import Functions from "./Functions";
import BankWidget from "./BankWidget";
import {
  DEPOSIT_SLIP_INPUT_ACCEPT,
  DEPOSIT_SLIP_UPLOAD_EXTENSIONS,
  DEPOSIT_SLIP_UPLOAD_MIME_TYPES,
  isAcceptedUploadFile,
} from "../../utils/uploadFiles";

const UploadDepositSlipPage = ({ match }) => {
  return (
    <>
      <NavigationMenus content={<UploadDepositSlip key={match.params.id} />} />
    </>
  );
};

class UploadDepositSlipBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      success: false,
      fundName: "",
      amount: "",
      picture: null,
      fileError: "",
      hasDepositSlip: false,
      transactionId: "",
      processingTimeline: "",
      processingTimelineInfo: "",
    };

    this.functions = new Functions();
  }

  static contextType = AuthUserContext;

  componentDidMount() {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "PHP",
      minimumFractionDigits: 2,
    });
    let transactionId = this.props.match.params.id;
    this.setState({ transactionId: transactionId });
    let uid = this.context.uid;
    const investmentRef = this.props.firebase.db.collection("transactions");
    investmentRef
      .where("clientDetails.userUid", "==", uid)
      .get()
      .then((snapshot) => {
        let selectedFundName = "";
        snapshot.docs.some((doc) => {
          if (doc.data().eventId === transactionId) {
            const data = doc.data();
            let hasDepositSlip = data.depositSlip === "" ? false : true;
            selectedFundName = data.fundDetails.fundName;
            this.setState({
              amount: formatter.format(data.amount),
              hasDepositSlip: hasDepositSlip,
              fundName: selectedFundName,
            });

            return true;
          } else {
            return false;
          }
        });

        if (!selectedFundName) return null;

        return this.props.firebase.db
          .collection("funds")
          .where("name", "==", selectedFundName)
          .limit(1)
          .get();
      })
      .then((snapshot) => {
        if (!snapshot || snapshot.empty) return;

        this.setState({
          processingTimeline:
            snapshot.docs[0].data().processingTimeline?.trim() || "",
          processingTimelineInfo:
            snapshot.docs[0].data().processingTimelineInfo?.trim() || "",
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  deletePicture = () => {
    this.fileInput.value = "";
    this.setState({ picture: null, fileError: "" });
  };

  handleChange = (event) => {
    if (event.target.name !== "picture") {
      this.setState({ [event.target.name]: event.target.value });
    } else {
      const file = event.target.files && event.target.files[0];
      if (
        !file ||
        !isAcceptedUploadFile(
          file,
          DEPOSIT_SLIP_UPLOAD_MIME_TYPES,
          DEPOSIT_SLIP_UPLOAD_EXTENSIONS
        )
      ) {
        event.target.value = "";
        this.setState({
          picture: null,
          fileError: "Upload a PNG, GIF, JPG/JPEG, or HEIC/HEIF file.",
        });
        return;
      }
      this.setState({ picture: file, fileError: "" });
    }
  };

  handleMoneyChange = (e) => {
    const newVal = e.target.value.replace(/[^\d]/, "");

    this.setState({
      amount: newVal,
    });
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, () => {
      this.functions
        .doUploadDepositSlip(this.state)
        .then(() => {
          this.setState({ loading: false, success: true });
        })
        .catch((err) => {
          this.setState({ loading: false, success: false }, () => {
            console.log(err);
          });
        });
    });
  };

  render() {
    document.body.style.backgroundColor = "white";
    const {
      success,
      amount,
      picture,
      fileError,
      loading,
      hasDepositSlip,
      fundName,
      processingTimeline,
      processingTimelineInfo,
    } = this.state;
    let transactionId = this.props.match.params.id;

    return (
      <>
        {success ? (
          <OverlayAlertBox
            processingTimeline={processingTimeline}
            processingTimelineInfo={processingTimelineInfo}
          />
        ) : (
          ""
        )}
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="textSecondary" href={ROUTES.DASHBOARD}>
            Dashboard
          </Link>
          <Link color="textSecondary" href={ROUTES.MY_INVESTMENTS}>
            Funds
          </Link>
          <Link
            color="textSecondary"
            href={`${ROUTES.INVESTMENT_HISTORY}/${transactionId}`}
          >
            {fundName}
          </Link>
          <Typography color="textPrimary" aria-current="page">
            Upload Deposit Slip
          </Typography>
        </Breadcrumbs>
        <div className="body-content">
          <form onSubmit={this.onSubmit} className="payment-details">
            {hasDepositSlip ? (
              <div style={{ textAlign: "center" }}>
                <h1>You already have a deposit slip.</h1>
              </div>
            ) : (
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <h1>Upload Deposit Slip</h1>
                  {/* <span>{this.state.date.toDateString()}</span> */}
                  <br /> <br />
                  <h2>Amount: {amount}</h2>
                  <br />
                  <div className="upload">
                    <div className="title">
                      <h3>Please upload your deposit slip</h3>
                      <InfoOutlined fontSize="small" />
                    </div>
                    <span>
                      Please make sure that the entered amount is the same in
                      the deposit slip
                    </span>
                    <p>
                      Supported files: PNG, GIF, JPG/JPEG, and HEIC/HEIF.
                      HEIC/HEIF files will be converted for compatibility.
                    </p>
                    <div className="upload-box">
                      <input
                        required
                        accept={DEPOSIT_SLIP_INPUT_ACCEPT}
                        type="file"
                        ref={(ref) => (this.fileInput = ref)}
                        className="upload-file"
                        name="picture"
                        onChange={(event) => this.handleChange(event)}
                      />
                      <span>Drag and drop a file here or browse</span>
                    </div>
                    {fileError && (
                      <p role="alert" style={{ color: "red" }}>
                        {fileError}
                      </p>
                    )}
                    <Paper className="custom-list-upload" component="ul">
                      {picture !== null && (
                        <Chip
                          icon={<AttachFileOutlined />}
                          label={picture.name}
                          onDelete={this.deletePicture}
                          className="custom-chip-upload"
                        />
                      )}
                    </Paper>
                    <br />
                    {loading ? (
                      <LinearProgress color="primary" />
                    ) : (
                      <Button
                        disabled={loading}
                        type="submit"
                        variant="contained"
                        color="primary"
                        className="custom-btn"
                        size="large"
                      >
                        Submit
                      </Button>
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <div className="payment-bank">
                    <BankWidget />
                  </div>
                  <div className="quick-note">
                    <h2>Quick Note</h2>
                    <span>
                      Your personal data will be used to process your order,
                      support your experience throughout this website, and for
                      other purposes described in our <b>privacy policy.</b>
                    </span>
                  </div>
                </Grid>
              </Grid>
            )}
          </form>
        </div>
      </>
    );
  }
}

const condition = (authUser) => !!authUser;

const UploadDepositSlip = compose(
  withAuthorization(condition),
  withRouter,
  withFirebase
)(UploadDepositSlipBase);

export default UploadDepositSlipPage;

export { UploadDepositSlip };
